import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const StreetIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M10.9504 1.71537C10.9504 1.13372 11.4183 0.665771 12 0.665771C12.5817 0.665771 13.0496 1.13372 13.0496 1.71537V2.06524H20.06C20.2743 2.06524 20.4755 2.16145 20.6067 2.32763L22.8458 5.12656C23.0514 5.38021 23.0514 5.7432 22.8458 6.00123L20.6067 8.80015C20.4755 8.96634 20.2743 9.06255 20.06 9.06255H13.0496V10.462H20.3968C21.1709 10.462 21.7962 11.0874 21.7962 11.8615V16.0599C21.7962 16.8339 21.1709 17.4593 20.3968 17.4593H13.0496V22.0076C13.0496 22.5892 12.5817 23.0572 12 23.0572C11.4183 23.0572 10.9504 22.5892 10.9504 22.0076V17.4593H3.93997C3.72567 17.4593 3.5245 17.3631 3.3933 17.1969L1.15416 14.398C0.948613 14.1444 0.948613 13.7814 1.15416 13.5233L3.3933 10.7244C3.5245 10.5582 3.72567 10.462 3.93997 10.462H10.9504V9.06255H3.60322C2.82914 9.06255 2.20376 8.43717 2.20376 7.66309V3.4647C2.20376 2.69062 2.82914 2.06524 3.60322 2.06524H10.9504V1.71537ZM4.30295 4.16443V6.96336H19.3865L20.5061 5.56389L19.3865 4.16443H4.30295ZM19.697 15.3601V12.5612H4.61346L3.49389 13.9607L4.61346 15.3601H19.697Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default StreetIcon
